/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllCarveOutTrackingResponse } from './FindAllCarveOutTrackingResponse';
import {
    FindAllCarveOutTrackingResponseFromJSON,
    FindAllCarveOutTrackingResponseFromJSONTyped,
    FindAllCarveOutTrackingResponseToJSON,
} from './FindAllCarveOutTrackingResponse';

/**
 * 
 * @export
 * @interface FindAllCarveOutTracking200Response
 */
export interface FindAllCarveOutTracking200Response {
    /**
     * 
     * @type {FindAllCarveOutTrackingResponse}
     * @memberof FindAllCarveOutTracking200Response
     */
    data?: FindAllCarveOutTrackingResponse;
}

/**
 * Check if a given object implements the FindAllCarveOutTracking200Response interface.
 */
export function instanceOfFindAllCarveOutTracking200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllCarveOutTracking200ResponseFromJSON(json: any): FindAllCarveOutTracking200Response {
    return FindAllCarveOutTracking200ResponseFromJSONTyped(json, false);
}

export function FindAllCarveOutTracking200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCarveOutTracking200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllCarveOutTrackingResponseFromJSON(json['data']),
    };
}

export function FindAllCarveOutTracking200ResponseToJSON(value?: FindAllCarveOutTracking200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllCarveOutTrackingResponseToJSON(value.data),
    };
}

